(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('section-type', {
            parent: 'entity',
            url: '/section-type',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.sectionType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section-type/section-types.html',
                    controller: 'SectionTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('section-type-detail', {
            parent: 'section-type',
            url: '/section-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.sectionType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section-type/section-type-detail.html',
                    controller: 'SectionTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectionType', function($stateParams, SectionType) {
                    return SectionType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'section-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('section-type.new', {
            parent: 'section-type',
            url: '/create',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/section-type/section-type-dialog.html',
                    controller: 'SectionTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('section-type.edit', {
            parent: 'section-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.sectionType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/section-type/section-type-dialog.html',
                    controller: 'SectionTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectionType', function($stateParams, SectionType) {
                    return SectionType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'section-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('section-type.delete', {
            parent: 'section-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/section-type/section-type-delete-dialog.html',
                    controller: 'SectionTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['SectionType', function(SectionType) {
                            return SectionType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('section-type', null, { reload: 'section-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
